import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: 'calc(33% - 15px)',
    marginRight: 15,
    marginBottom: 15,
    padding: 20,
    background: '#F2F4F8',
    borderRadius: 2,
    '&:nth-child(3n)': {
      marginRight: 0,
    },
  },
  substitute: {
    marginTop: 20,
    border: '1px solid #ccc',
  },
  substituteTitle: {
    display: 'block',
    marginBottom: 10,
    fontSize: 14,
    color: '#646464',
  },
  title: {
    margin: 0,
    fontSize: 14,
    fontWeight: 600,
    color: theme.custom.darkBlue,
  },
  text: {
    wordBreak: 'break-word',
  },
  list: {
    margin: 0,
    marginTop: 10,
    padding: 0,
    paddingLeft: 10,
    listStyle: 'none',
  },
  listItemText: {
    fontSize: 13,
    fontWeight: 400,
    color: '#646464',
    textDecoration: 'none',
  },
  link: {
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  phoneNumber: {
    marginRight: 15,
  },
}));
